<template>
  <div
    :class="{
      excluded: hoverCand == candidate.email && !type,
    }"
  >
    <div
      class="kanban-main-cards d-flex"
      :style="!tagFiltered && 'border-radius: 8px !important'"
      :class="candidateDocsUploaded && 'docs-uploaded-border'"
    >
      <div class="w-15 position-relative">
        <div
          class="mr-2 position-relative"
          :class="
            showGrayTick
              ? 'avatar-gray-tick'
              : showWhiteTick
              ? 'avatar-blue-tick'
              : candidate.customFields &&
                candidate.customFields.imageMedia &&
                candidate.customFields.imageMedia != null
              ? 'common-sm-profile-transparet-icon'
              : 'common-sm-profile-icon'
          "
        >
          <template
            v-if="
              !triggerReport &&
              !sendScreening &&
              (!triggerCVS || candidate.cvsStatus == 2)
            "
          >
            <b-avatar
              v-if="
                candidate.customFields &&
                candidate.customFields.imageMedia &&
                candidate.customFields.imageMedia != null
              "
              :src="candidate.customFields.imageMedia"
            ></b-avatar>
            <b-avatar v-else :text="candidate.name[0].toUpperCase()"></b-avatar>
          </template>
          <b-avatar
            v-else-if="triggerReport"
            button
            @click="$emit('trigger-report-cand')"
            :src="getTriggerIcon"
          ></b-avatar>
          <b-avatar
            v-else
            button
            @click="$emit('trigger-cvs-cand')"
            :src="getTriggerIcon"
          ></b-avatar>
        </div>
        <div
          v-if="candidateDocsUploaded"
          class="
            pushed-cand-dp
            d-flex
            align-items-center
            justify-content-center
          "
          v-b-tooltip.hover.bottom="
            candidate.documentStatus == 3
              ? 'Candidate is yet to submit the documents'
              : 'Document approval is pending'
          "
        >
          <img src="../../assets/img/newkanban/docs-uploaded.svg" alt />
        </div>

        <b-avatar
          v-else-if="addedByVendor && !type"
          :text="getVendorName[1][0].toUpperCase()"
          v-b-tooltip.hover.bottom="`${getVendorName[0]}`"
          class="pushed-cand-avatar"
        ></b-avatar>
      </div>
      <div class="w-85">
        <div class="d-flex align-items-center">
          <div class="w-75 text-truncate kanban-maincards-mainhead">
            {{ candidate.name }}
          </div>
          <div class="w-25 d-flex align-items-center position-relative">
            <img
              v-if="
                selectedCandidate.candidateID == candidate.candidateID &&
                viewCandidateModal
              "
              src="../../assets/img/newcreatejob/hideicon.svg"
              alt
              class="pointer"
            />
            <img
              v-else
              :class="isSchedule && 'disabled-kanban-img'"
              @click="!isSchedule && $emit('view-candidate')"
              src="../../assets/img/newkanban/view.svg"
              alt
              class="pointer"
            />
            <img
              @click.stop="
                isSchedule || jobOnHold
                  ? ''
                  : selectedID != candidate.candidateID
                  ? selectCand()
                  : closeCand()
              "
              tabindex="0"
              :class="(isSchedule || jobOnHold) && 'disabled-kanban-img'"
              class="ml-2 kanban-image-hover pointer"
              src="../../assets/img/newkanban/more.svg"
              alt
            />
            <div
              :ref="'closecard' + candidate.candidateID"
              v-if="selectedID == candidate.candidateID"
              class="kanban-more-option-card"
            >
              <div
                class="kanban-more-option-card-input"
                @click="$emit('trigger-assessment')"
              >
                <img :src="getAssessIcon()" class="mr-1" alt />
                {{ candidate.kanbanScheduled ? "Retrigger" : "Trigger" }}
                Assessment
              </div>
              <div
                v-if="showMoveToOnHold"
                @click="moveToFinal()"
                class="kanban-more-option-card-input"
              >
                <img
                  src="../../assets/img/newkanban/reviewdocuments.svg"
                  class="mr-2"
                  alt
                />
                Move To Final
              </div>
              <div
                class="kanban-more-option-card-input"
                v-if="candidate.kanbanScheduled"
                @click="$emit('give-feedback')"
              >
                <img
                  src="../../assets/img/newkanban/moreoptionicons/givefdbck.svg"
                  class="mr-1"
                  alt
                />
                Give Feedback
              </div>
              <div
                v-if="candidate.feedbackHistory"
                class="kanban-more-option-card-input"
                @click="$emit('view-feedback')"
              >
                <img
                  src="../../assets/img/newkanban/moreoptionicons/viewfdbck.svg"
                  class="mr-1"
                  alt
                />
                View Feedback
              </div>
              <div
                v-if="!candidate.kanbanScheduled"
                class="kanban-more-option-card-input"
                @click="$emit('not-interested')"
              >
                <img
                  src="../../assets/img/newkanban/moreoptionicons/ni.svg"
                  class="mr-1"
                  alt
                />
                Not Interested
              </div>
              <div
                v-if="!type && particularJob.positionIDs.length > 1"
                class="kanban-more-option-card-input"
                @click="$emit('change-position')"
              >
                <img
                  src="../../assets/img/newkanban/change-position.svg"
                  class="mr-2"
                  alt
                />
                Change Position ID
              </div>
              <div
                v-if="!type && roles.includes('REASSIGN_CANDIDATE')"
                class="kanban-more-option-card-input"
                @click="$emit('re-assign')"
              >
                <img
                  src="../../assets/img/newkanban/moreoptionicons/reassign.svg"
                  class="mr-1"
                  alt
                />
                Reassign
              </div>
              <div
                v-if="
                  (!type && candidate.documentStatus == 5) ||
                  candidate.documentStatus == 2 ||
                  candidate.documentStatus == 4
                "
                class="kanban-more-option-card-input"
                @click="$emit('goto-viewodcs', candidate.candidateID)"
              >
                <img
                  src="../../assets/img/newkanban/reviewdocuments.svg"
                  class="mr-2"
                  alt
                />
                Review Documents
              </div>
              <div
                v-if="
                  candidate.documentStatus == 3 ||
                  candidate.documentStatus == 0 ||
                  (type && candidate.documentStatus == 6)
                "
                class="kanban-more-option-card-input"
                @click="closeCand(), $emit('request-docs')"
              >
                <img
                  src="../../assets/img/newkanban/reviewdocuments.svg"
                  class="mr-2"
                  alt
                />
                Request Documents
              </div>
              <div
                @click="addAttach = !addAttach"
                :style="
                  addAttach && 'background: rgb(200, 217, 229) !important;'
                "
                class="kanban-more-option-card-input relativeclass"
              >
                <div class="d-flex justify-content-between">
                  <div>
                    <img
                      src="../../assets/new-icons/attachment-icon.svg"
                      class="mr-1"
                      alt
                    />
                    Add Attachment
                  </div>
                  <img
                    v-if="addAttach"
                    src="../../assets/new-kanban-icons/up-arrow.svg"
                    class="mr-1"
                    alt
                  />
                  <img
                    v-else
                    src="../../assets/new-kanban-icons/down-arrow.svg"
                    class="mr-1"
                    alt
                  />
                </div>
                <div
                  v-if="addAttach"
                  class="status-dropdown d-flex w-100 px-3 py-2"
                >
                  <div>
                    <img
                      src="../../assets/new-kanban-icons/straight-big-line.svg"
                      alt
                    />
                  </div>

                  <!-- status-dropdown-inner-container-selected -- bind this -->
                  <div class="status-dropdown-inner-container ml-2">
                    <div
                      class="status-dropdown-inner-container-unselected"
                      @click="
                        (addAttach = false),
                          $emit('show-add-attachment', candidate)
                      "
                    >
                      Media
                    </div>
                    <div
                      @click="
                        (addAttach = false), $emit('show-add-note', candidate)
                      "
                      class="status-dropdown-inner-container-unselected"
                    >
                      Note
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center w-100">
          <img src="../../assets/img/newkanban/mail.svg" alt />
          <span class="w-70 text-truncate kanban-maincards-mailncall ml-1">{{
            candidate.email
          }}</span>
        </div>
        <div class="mt-1 w-100">
          <div class="d-flex align-items-center justify-content-between w-100">
            <div
              class="tip-learn-more font-lato"
              v-if="triggerCVS && candidate.cvsStatus == 2"
            >
              CVS Score:
              <span class="fw-600">{{
                candidate.cvsScore ? `${candidate.cvsScore}/50` : "0/50"
              }}</span>
            </div>
            <div v-else class="kanban-maincards-mailncall">
              <img src="../../assets/img/newkanban/phone.svg" alt />
              {{ candidate.phoneNumber }}
            </div>

            <div
              v-if="candidate.processing"
              class="kanban-maincards-processing"
              style="color: #20639b"
            >
              Processing
            </div>
            <div
              v-else-if="triggerReport"
              class="kanban-maincards-nottriggered"
              :style="reportStatus.style"
              v-b-tooltip.hover.bottom="reportStatus.tooltip"
            >
              {{ reportStatus.label }}
            </div>
            <div
              v-else-if="!triggerCVS && !sendScreening"
              class="kanban-maincards-nottriggered"
              :style="
                assessStatus === 'Not Yet Started' ||
                assessStatus == 'Ongoing' ||
                assessStatus == 'Not Evaluated' ||
                candNoShow
                  ? 'color:#FFC145'
                  : assessStatus == 'Completed' || assessStatus == 'Pass'
                  ? 'color:#038E00'
                  : assessStatus == 'Not Evaluated' || assessStatus == 'Fail'
                  ? 'color : #EB0002'
                  : 'color:#20639B'
              "
            >
              {{ assessStatus }}
            </div>
            <div
              v-else-if="triggerCVS"
              class="kanban-maincards-nottriggered"
              :style="
                candidate.cvsStatus == 1
                  ? 'color: #8C8C8C;'
                  : candidate.cvsStatus == 2
                  ? 'color: #038E00;'
                  : 'color: #20639B;'
              "
            >
              {{ getCVSStatus }}
            </div>
            <div
              v-else-if="sendScreening && getScreeningNames.length != 0"
              class="
                kanban-maincards-nottriggered
                text-truncate
                d-inline-block
                defaultCursor
              "
              style="color: #20639b; max-width: 105px"
              :style="
                getScreeningNames.length > 1
                  ? 'width: 105px;'
                  : 'max-width: 105px;'
              "
            >
              <div
                v-if="getScreeningNames.length > 1"
                class="d-flex flex-wrap justify-content-center"
              >
                <b-avatar-group class="common-avatar-white-border">
                  <b-avatar
                    class="screening-panel-avatar"
                    v-for="(panel, index) in getScreeningNames.slice(0, 4)"
                    :key="index"
                    :text="panel[0]"
                    v-b-tooltip.hover.bottom="panel"
                  >
                  </b-avatar>
                  <b-avatar
                    v-b-tooltip.hover.bottom="
                      getScreeningNames.slice(4).join(', ')
                    "
                    v-if="getScreeningNames.length > 4"
                    class="panel-lightblue-div pointer"
                  >
                    +{{ getScreeningNames.length - 4 }}
                  </b-avatar>
                </b-avatar-group>
              </div>
              <span v-b-tooltip.hover.bottom="getScreeningNames[0]" v-else>{{
                getScreeningNames[0]
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      ref="container"
      v-if="
        !type &&
        tagFiltered &&
        candidate.customFields.notesTags &&
        candidate.customFields.notesTags.length != 0
      "
      class="kanbancard-tags-container d-flex align-items-center gap-10"
    >
      <div
        v-for="(tag, index) in visibleTags"
        :key="index"
        class="kanbancards-skilltags fs-12 fw-400 font-lato color-mainblue"
        :style="
          visibleTags.length == 1 &&
          (remainingCount > 1 ||
            (remainingCount === 1 && visibleTags.length > 0)) &&
          'max-width: 195px !important;'
        "
        :class="visibleTags.length == 1 && 'kanban-tag-truncate'"
      >
        #{{ tag }}
      </div>

      <div
        :ref="'showmoreskills' + candidate.candidateID"
        v-if="
          remainingCount > 1 || (remainingCount === 1 && visibleTags.length > 0)
        "
        :id="'showmoreskills' + candidate.candidateID"
        class="
          kanbancards-skilltags
          fs-12
          fw-400
          font-lato
          color-mainblue
          pointer
        "
      >
        +{{ remainingCount }} more
      </div>
      <b-tooltip
        @shown="onTooltipShown"
        ref="tooltip"
        :target="'showmoreskills' + candidate.candidateID"
        triggers="click"
        placement="bottom"
        @hidden="$emit('show-blur', false)"
        :id="'tooltip' + candidate.candidateID"
        :custom-class="'kanban-skill-tooltip'"
      >
        <template
          v-if="candidate.notes && Object.keys(candidate.notes).length != 0"
        >
          <div class="fs-12 fw-600 font-mont color-e0e0e0">
            {{ candidate.notes.noteCreatedBy }}
            <span class="color-abb1b9 fs-11 fw-500 font-lato font-italic">
              ({{ candidate.notes.createdAt }})
            </span>
          </div>
          <div class="font-mont fw-500 fs-12 color-white mt-1">
            {{ candidate.notes.note }}
          </div>
        </template>

        <div
          ref="tooltipTags"
          class="mt-2 d-flex align-items-center gap-10 flex-wrap"
        >
          <div
            v-for="(tag, index) in visibleSubTags"
            :key="index"
            class="kanbancards-skilltags fs-12 fw-400 font-lato color-mainblue"
          >
            #{{ tag }}
          </div>
          <div
            @click="$emit('view-candidate', 'show-note')"
            v-if="count > 0"
            class="
              kanbancards-skilltags
              fs-12
              fw-400
              font-lato
              color-mainblue
              pointer
            "
          >
            +{{ count }} more
          </div>
        </div>
      </b-tooltip>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getCVSStatus,
  showWhiteTick,
  showGrayTick,
  getTriggerIcon,
  calculateVisibleSubTags,
  calculateVisibleTags,
  removeTooltip,
} from "./kanbanHelpers";
export default {
  data() {
    return {
      addAttach: false,
      visibleTags: [],
      remainingCount: 0,
      visibleSubTags: [],
      count: 0,
    };
  },
  props: {
    type: String,
    candidate: Object,
    isSchedule: Boolean,
    jobOnHold: Boolean,
    selectedID: String,
    selectedCandidate: Object,
    viewCandidateModal: Boolean,
    particularJob: Object,
    triggerCVS: Boolean,
    triggerReport: Boolean,
    triggerCands: Array,
    sendScreening: Boolean,
    tagFiltered: Boolean,
    hoverCand: String,
  },
  computed: {
    ...mapGetters({ roles: "roles" }),
    showMoveToOnHold() {
      return (
        !this.type &&
        !this.candidate.kanbanScheduled &&
        this.candidate.kanbanLevel != 0 &&
        this.candidate.kanbanLevel != "F" &&
        this.candidate.kanbanLevel != "NI" &&
        this.candidate.kanbanLevel != "R"
      );
    },
    assessStatus() {
      if (!this.candidate.kanbanScheduled && this.candNoShow) return "No Show";
      else if (this.candidate.kanbanScheduled) {
        if (this.candidate.assessmentResponse.status == 0) {
          return "Not Yet Started";
        } else if (this.candidate.assessmentResponse.status == 1) {
          return "Ongoing";
        } else if (this.candidate.assessmentResponse.status == 2) {
          if (
            this.candidate.assessmentResponse.evaluationStatus == null ||
            this.candidate.assessmentResponse.evaluationStatus == false
          ) {
            return "Not Yet Evaluated";
          } else if (this.candidate.assessmentResponse.passingStatus.status) {
            return this.candidate.assessmentResponse.passingStatus.status;
          } else {
            return "Completed";
          }
        }
      }
      return "Not Triggered";
    },
    candNoShow() {
      return (
        this.candidate.customerID?.[this.particularJob.customerID]?.[
          this.particularJob.jobID
        ]?.status == "DNA"
      );
    },
    ...mapGetters("userVUEX", {
      projectUsers: "getProjectUsers",
    }),
    getDocsRejRec() {
      if (this.$route.name != "VendorKanban") {
        if (this.candidate.documentStatus != null) {
          if (
            this.candidate.customerID[this.$route.query.customerID][
              this.$route.query.jobID
            ].documentRejectedByRecruiter != null
          ) {
            return this.candidate.customerID[this.$route.query.customerID][
              this.$route.query.jobID
            ].documentRejectedByRecruiter;
          }
        }
      }
      return false;
    },
    getVendorName() {
      var id;
      if (
        this.candidate.customerID[this.particularJob.customerID][
          this.particularJob.jobID
        ].pushedBy
      ) {
        id =
          this.candidate.customerID[this.particularJob.customerID][
            this.particularJob.jobID
          ].pushedBy;
      } else {
        id = this.candidate.createdBy;
      }
      let name = this.projectUsers[id].username;
      let text = `Pushed by vendor "${name}"`;
      return [text, name];
    },
    addedByVendor() {
      if (this.particularJob) {
        if (
          this.candidate.customerID[this.particularJob.customerID][
            this.particularJob.jobID
          ].addedByVendor
        ) {
          return this.candidate.customerID[this.particularJob.customerID][
            this.particularJob.jobID
          ].addedByVendor;
        }
      }
      return false;
    },
    candidateDocsUploaded() {
      return (
        this.candidate.documentStatus != null &&
        ((!this.type && this.candidate.documentStatus != 1) ||
          (this.type && this.candidate.documentStatus != 5))
      );
    },
    getCVSStatus() {
      return getCVSStatus(this.candidate);
    },
    getTriggerIcon() {
      return getTriggerIcon(this);
    },
    reportStatus() {
      if (this.candidate.reportUpdateAvailable)
        return {
          label: "Update available",
          style: "color: #038E00;",
          tooltip: "CVS was taken after this report was generated",
        };
      if (!this.candidate.reportKey)
        return {
          label: "No report",
          style: "color: #20639B;",
          tooltip: "No match report generated yet",
        };
      return {
        label: this.candidate.recommendation
          ? this.verdictLabel(this.candidate.recommendation)
          : "View Report",
        style: this.candidate.recommendation
          ? this.verdictColor(this.candidate.recommendation)
          : "color: #8C8C8C;",
        tooltip: "Report reflects all available evidence",
      };
    },
    showWhiteTick() {
      return showWhiteTick(this);
    },
    showGrayTick() {
      return showGrayTick(this);
    },
    getScreeningNames() {
      return this.candidate.screeningAssignedTo.map((obj) => {
        return this.formattedData(obj.username);
      });
    },
  },
  mounted() {
    document.addEventListener("click", this.closeOnOutside);
    if (
      !this.type &&
      this.candidate.customFields.notesTags &&
      this.candidate.customFields.notesTags.length != 0
    ) {
      this.calculateVisibleTags();
      this.calculateVisibleSubTags(this.candidate.customFields.notesTags);
      window.addEventListener("resize", this.calculateVisibleTags);
    }
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeOnOutside);
    if (
      !this.type &&
      this.candidate.customFields.notesTags &&
      this.candidate.customFields.notesTags.length != 0
    ) {
      window.removeEventListener("resize", this.calculateVisibleTags);
    }
  },
  methods: {
    verdictLabel(rec) {
      if (rec.fit) return rec.fit.band;
      const map = { ADVANCE: "Strong Fit", HOLD: "Review", REJECT: "No Fit" };
      return (rec && map[rec.decision]) || "View Report";
    },
    verdictColor(rec) {
      const token = rec && rec.fit && rec.fit.token;
      if (token) {
        const tokenColors = {
          good: "#038e00",
          warn: "#ffc145",
          crit: "#eb0002",
          neu: "#5a6472",
        };
        return `color: ${tokenColors[token] || "#5a6472"}`;
      }
      const decision = rec && rec.decision;
      if (decision === "ADVANCE") return "color: #038e00";
      if (decision === "REJECT") return "color: #eb0002";
      return "color: #ffc145";
    },
    removeTooltip() {
      removeTooltip(this);
    },
    onTooltipShown() {
      this.$emit("show-blur", true);
    },
    calculateVisibleTags() {
      calculateVisibleTags(this);
    },
    calculateVisibleSubTags(tags) {
      calculateVisibleSubTags(tags, this);
    },
    formattedData(data) {
      return data.replace(/\b\w/g, (char) => char.toUpperCase());
    },
    moveToFinal() {
      this.$emit("move-to-final", this.candidate);
    },
    selectCand() {
      if (!this.type && this.hoverCand == this.candidate.email)
        this.removeTooltip();
      this.$emit("select-cand", this.candidate.candidateID);
      this.addAttach = false;
    },
    closeCand() {
      this.$emit("select-cand", "");
      this.addAttach = false;
    },
    getAssessIcon() {
      if (this.candidate.kanbanScheduled) {
        return require("../../assets/img/newkanban/moreoptionicons/retriggerasmnt.svg");
      }
      return require("../../assets/img/newkanban/moreoptionicons/triggerasmnt.svg");
    },
    closeOnOutside(event) {
      let id = "closecard" + this.candidate.candidateID;
      if (this.$refs[id] && !this.$refs[id].contains(event.target)) {
        this.$emit("select-cand", "");
        this.addAttach = false;
        // Close the dropdown
      }
      if (!this.type) {
        const triggerRef =
          this.$refs["showmoreskills" + this.candidate.candidateID];
        // const tooltipEl = document.getElementById("tooltip-" + this.candidate.candidateID);
        // If click is outside both the trigger and the tooltip, close
        if (triggerRef && !triggerRef.contains(event.target)) {
          this.removeTooltip();
        }
      }
    },
  },
};
</script>
<style scoped>
.kanban-maincards-processing {
  padding: 3px 10px;
  font-family: "Lato", sans-serif;
  font-weight: 600;
  font-style: italic;
  font-size: 12px;
  background: #f6f9fb;
  border-radius: 8px;
  display: flex;
  justify-content: center;
}
</style>
